import type { FactoryLayoutContentItem, FactoryStructuralUnit } from '../../services/factoryService';
import { stripImageDescriptions } from './stripImageDescriptions';

/**
 * Prefer per-item texts from aggregation meta over truncated textPreview.
 * Joining on item boundaries keeps $…$ / \\frac intact for KaTeX.
 */
export function structuralUnitPreviewLines(unit: FactoryStructuralUnit): string[] {
  const fromItems = (unit.contentItems || [])
    .map((it: FactoryLayoutContentItem) => stripImageDescriptions(String(it.text || '').trim()))
    .filter(Boolean);
  if (fromItems.length) return fromItems;

  const preview = stripImageDescriptions(String(unit.textPreview || '').trim());
  if (!preview) return [];
  return preview.split(/\n+/).map((line) => line.trim()).filter(Boolean);
}
